export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0-4h24v24H0z\"/><path class=\"path\" d=\"M16.506 6C18.446 6 20 4.66 20 3s-1.554-3-3.494-3C14.566 0 13 1.34 13 3s1.566 3 3.506 3zm-9 0C9.446 6 11 4.66 11 3S9.446 0 7.506 0C5.566 0 4 1.34 4 3s1.566 3 3.506 3zM7.5 9C5.004 9 0 10.17 0 12.5V15h15v-2.5C15 10.17 9.996 9 7.5 9zm8.595 0c-.327 0-.7.02-1.095.05 1.31.84 2.225 1.97 2.225 3.45V15H24v-2.5c0-2.33-5.274-3.5-7.905-3.5z\" fill=\"#000\" fill-rule=\"nonzero\"/></g>",
  "attrs": {
    "width": "24",
    "height": "15",
    "viewBox": "0 0 24 15",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};